import { Button, Flex, Heading, Input, Text } from "@pancakeswap/uikit";
import styled from "styled-components";

export const CsHeading = styled(Heading)`
    font-size: 40px;
    @media screen and (max-width:600px) {
        font-size: 22px;
    }
`
export const CsBack = styled(Heading)`
    font-size: 32px;
    @media screen and (max-width:600px) {
        font-size: 18px;
    }
`

export const CsSubHeading = styled(Text)`
    font-size: 40px;
    color: ${({ theme }) => theme.colors.primary};
    font-size: 22px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.48px;
    @media screen and (max-width:600px) {
        font-size: 18px;
    }
`
export const CsButton = styled(Button)`
    padding: 0px 4px;
    font-size: 13px;
    border-radius: 40px;
    height: 48px;
    @media screen and (max-width:600px){
        font-size: 12px;
        height: 40px;
    }
`

export const CsButtonTab = styled(Button)<{disabled: boolean}>`
    border-radius: 12px;
    padding: 0px 4px;
    font-size: 13px;
    height: 48px;
    /* &:hover{
        background: linear-gradient(119deg, #FA9406 0%, #FFBD1D 100%);
        color: ${({theme}) => theme.colors.white}
    } */
    @media screen and (max-width:600px){
        border-radius: 12px;
        font-size: 12px;
        height: 40px;
        width: 50%;
    }
`
export const CsFlex = styled(Flex)`
    width: 100%;
`

export const GirdColum = styled(Flex)`
    display: grid;
    width: 100%;
    grid-template-columns: repeat(4,1fr);
    grid-gap: 1rem;
    margin-top:2rem;
    @media screen and (max-width:768px) {
        grid-template-columns: repeat(2, 1fr);
    }
    @media screen and (max-width:600px) {
        grid-template-columns: 1fr
    }
`
 
export const WrapCount = styled(Flex)`
    gap: 6px;
    align-items: center;
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid #000;
    border-radius: 12px;
    width: 100%;
    height: 47px;
    padding: 4px;
`;
export const ButtonQuanlity = styled(Button)`
    border-radius: 4px;
    display: flex;
    width: 36px;
    height: 36px;
    padding: 11px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    box-shadow: none;
    border-radius: 12px;
    /* background: ${({ theme }) => theme.colors.bgBtn}; */
    background: linear-gradient(90deg, #0367F3 0%, #03237C 100%);
`;

export const CustomInput2 = styled(Input)`
    color: ${({ theme }) => theme.colors.text};
    padding: 0 1rem;
    width: 100%;
    height: 100%;
    text-align: left;
    border: none;
    box-shadow: none;
    font-size: 16px;
    border-radius: 11.526px;
    background: #EFEFEF;
    min-width:320px;
    width: 100%;
    height: 48px;
    &::placeholder {
        color: ${({ theme }) => theme.colors.default};
    }
    @media screen and (max-width: 1000px) {
        font-size: 14px;
    }
`;


export const CustomInput = styled(Input)`
    color: ${({ theme }) => theme.colors.text};
    padding: 0 1rem;
    width: 100%;
    height: 100%;
    text-align: center;
    border: none;
    box-shadow: none;
    font-size: 16px;
    border-radius: 11.526px;
    background: none;
    width: 100%;
    height: 48px;
    font-weight: 700;
    &::placeholder {
        color: ${({ theme }) => theme.colors.text};
    }
    @media screen and (max-width: 1000px) {
        font-size: 14px;
    }
`;
export const SubBalance = styled(Text)`
    color: #9596A6;
    font-style: normal;
    font-weight: 400;
    line-height: 124.5%;
`


export const CsButtonContinue = styled(Button)`
    border-radius: 4px;
`
export const CsWrapInfo = styled(Flex)`
    border-radius: 8px;
    border: 1px solid ${({theme}) => theme.colors.border};
    padding: 1rem 2rem;
    gap: 30px;
    ${Text}{
        font-size: 16px;
    }
    @media screen and (max-width: 768px){
        gap: 0.5rem;
        padding: 1rem;
        flex-direction: column;
        width:100%;
        ${Text}{
            font-size: 14px;
        }
    }
`
export const Hr = styled.hr`
        display: block;
    @media screen and (max-width: 768px){
        display: none;
    }
`
export const CsGiftCardInfoPC = styled(Flex)`
    width: 100%;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 8px;
    border: 1px solid ${({theme}) => theme.colors.border};
    padding: 1rem 1rem;
    
    @media screen and (max-width: 768px){
        display:none;
        flex-direction: row;
        padding: 1rem;
    }
`
export const CsGiftCardInfoMobile = styled(Flex)`
        display:none;
        @media screen and (max-width: 768px){
            display: flex;
            border-radius: 8px;
            padding: 1rem 1rem;
            flex-direction: column;
            border: 1px solid ${({theme}) => theme.colors.border};
        }
`
export const CsFlexLine = styled(Flex)`
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    gap: 10px;
    ${Text}{
        font-size: 16px;
        @media screen and (max-width: 768px){
            font-size: 14px;
        }
    }
    &:first-child{
        padding-bottom: 0.5rem;
        border-bottom: 1px solid ${({theme}) => theme.colors.border};
        @media screen and (max-width: 768px){
            padding-bottom: 0;
        }
    }
    &:last-child{
        margin-top: 1rem;
    }
    @media screen and (max-width: 768px){
        flex-direction: column;
        width: 50%;
        &:first-child{
            border-bottom: none;
            padding-bottom: 0;
            width: 32%;
        }
        &:last-child{
            margin-top: 0rem;
            width: 67%;
        }
    } 
`
export const RowItem = styled(Text)<{isFirst?:boolean}>`
    text-align: ${({isFirst}) => isFirst ? 'left' : 'center' };
    width: 20%;
    @media screen and (max-width: 768px){
        width: 100%;
        text-align: right;
    }
`

export const RowItemHeading = styled(Text)<{isFirst?:boolean}>`
    text-align: ${({isFirst}) => isFirst ? 'left' : 'center' };
    white-space: nowrap;
    width: 20%;
    @media screen and (max-width: 768px){
        width: 100%;
        text-align: left;
    }
`

export const Card = styled(Flex)`
    width: 50%;
    height: 100px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    padding: 0 40px;
    .textPoint{
        z-index: 10;
        font-size: 20px;
        @media screen and (max-width:768px){
            font-size: 16px;
        }
    }
    @media screen and (max-width:1000px){
    padding: 0 20px;
    }
    @media screen and (max-width:768px) {
        margin: 0 auto;
        width: 100%;
        height: 80px;
    }
    @media screen and (max-width:550px){
        padding: 0 35px;
    }
`
export const CsTagPrice = styled(Flex)`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
`
export const CsFlexCard = styled(Flex)`
    flex-direction: row;
    justify-content: flex-start;
    gap: 2rem;
    @media screen and (max-width:600px) {
        gap: 1rem;
        flex-direction: column;    
    }
`